import { ProductList } from '@/features/products/ProductList';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/products/')({
  staticData: { nav: 'products' },
  validateSearch: z.object({
    q: z.string().optional(),
    category: z.string().optional(),
    flag: z.string().optional(),
    ai_visible: z.string().optional(),
    availability: z.string().optional(),
    lifecycle: z.string().optional(),
    sort: z.string().optional(),
  }),
  component: ProductList,
});
